import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CoopValidators } from '@core/helpers/validators.helper';
import { liquidazioneDefaultDescValidator, liquidazioneDefaultValidator, my_NIscrizRevis, SezIIAccertamentoFormValidators } from './validators/sez-II-accertamento.form-validators';
import { SezIIAccertamentoStoreValidators } from './validators/sez-II-accertamento.store-validators';
import { SezIIAccertamentoWarningService } from './validators/sez-II-accertamento.warnings';
import { altreNotLibriSocialiRules } from '../altre-not-libri-soc/validators/altre-not-libri-soc.form-validators';
import { SezIIAccertamentoFormListeners } from './validators/sez-II-accertamento.form-listeners';
import { BaseRevisioneFormService } from '../../abstracts/base-revisione-form.service';

@Injectable()
export class SezIIAccertamentoFormService extends BaseRevisioneFormService<SezIIAccertamentoWarningService, SezIIAccertamentoStoreValidators> {
    constructor(protected validators: SezIIAccertamentoStoreValidators, protected warningService: SezIIAccertamentoWarningService) {
        super(warningService, validators);
    }

    override initListener(): void {
        new SezIIAccertamentoFormListeners(this._form, this.store);
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_Conclusioni: this.fb.group({
                        my_IrregSanabili: this.fb.group({
                            my_ElIrregSanabili: this.fb.array([]),
                        }),
                    }),

                    my_Bilancio: this.fb.group({
                        my_AnnoPrimoEs: '',
                        my_AnnoSecondoEs: '',
                    }),

                    my_DatiBilancio: this.fb.group({
                        my_StatoPatrimoniale__Attivo: this.fb.group({
                            my_StPaAtBtot2: '',
                            my_StPaAtBIItot2: '',
                            my_StPaAtCtot2: '',
                            my_StPaAtCItot2: '',
                            my_StPaAtCIItot2: '',
                        }),
                        my_StatoPatrimoniale__Passivo: this.fb.group({
                            my_StPaPsAtot2: '',
                            my_StPaPsDtot2: '',
                            my_StPaPsDa2: '',
                            my_StPaPsTOT2: '',
                        }),
                    }),

                    my_AltreNotizie: this.fb.group({
                        my_DescVertenzeGiudiz: '',
                        my_CkVertenzeGiudiz: '',
                        my_VertenzeGiudizImpPres: '',
                    }),

                    my_DatiIdentificativi: this.fb.group({
                        my_NIscrizRevis: ['', [my_NIscrizRevis]],
                        my_IncaricRevis: ['', [CoopValidators.required('Campo obbligatorio')]],
                        my_DenominazEnte: '',
                        my_IndirizzoSedeLegale: '',
                        my_ProvinciaSedeLegale: '',
                        my_ComuneSedeLegale: '',
                        my_CapSedeLegale: '',
                        my_LocalitaSedeLegale: '',
                        my_SpecificaTelefonoSedeLegale: '',
                        my_SpecificaFaxSedeLegale: '',
                        my_SpecificaMailSedeLegale: '',
                        my_PECcci: '',
                        my_AltraPEC: '',
                        my_SpecificaSitoWebSedeLegale: '',
                        my_CodFisc: '',
                        my_PartitaIVA: '',
                        my_PosizAlboEnti: '',
                        my_CkMutualPrev: '',
                        my_SezEnte: '',
                        my_RegimeDerogatorioProvalenza: '',
                        my_CkRientranteInRegimeDerogatorio: '',
                    }),
                }),

                my_SezioneII__Accertamento: this.fb.group({
                    my_Anno1II: '',
                    my_Anno2II: '',
                    my_AnnoRevisionePerAnnualiII: '',
                    my_DenominazEnteII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_DenominazEnteII')],
                    my_IndirizzoSedeLegaleII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_IndirizzoSedeLegaleII')],
                    my_CodFiscII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_CodFiscII')],
                    my_PartitaIVAII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_PartitaIVAII')],
                    my_PosizAlboEntiII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_PosizAlboEntiII')],
                    my_SezEnteII: ['', null, this.validatorsService.my_SezEnteII],
                    my_MatricolaII: ['', null, this.validatorsService.my_MatricolaII],
                    my_RevisoreII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_RevisoreII')],
                    my_RappresentanteCoopSceltaII: '',
                    my_DataCompilazII: ['', null, this.validatorsService.my_DataCompilazII],
                    my_QualitaRappresII: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_QualitaRappresII')],
                    my_LuogoCompilazII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_LuogoCompilazII')],
                    my_NOriginaliII: [
                        '',
                        null,
                        // this.validators.defaultValidatorConTipoAccertamento('my_NOriginaliII')  //// verificare
                    ],
                    my_CkMutualPrevII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_CkMutualPrevII')],
                    my_DocumRappresII: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_DocumRappresII')],
                    my_AssistRappresII: [''],
                    my_ProvinciaSedeLegaleII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_ProvinciaSedeLegaleII')],
                    my_ComuneSedeLegaleII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_ComuneSedeLegaleII')],
                    my_CapSedeLegaleII: [
                        '',
                        [CoopValidators.required, CoopValidators.pattern(/^[0-9]{5}$/, 'CAP non valido. Il CAP deve essere composto da 5 numeri')],
                        this.validatorsService.defaultAccertamentoValidator('my_CapSedeLegaleII'),
                    ],
                    my_SpecificaTelefonoSedeLegaleII: '',
                    my_SpecificaFaxSedeLegaleII: '',
                    my_SpecificaMailSedeLegaleII: ['', [CoopValidators.required, CoopValidators.pattern(/([a-zA-Z0-9_\-\.]+)@((([a-zA-Z0-9\-]{1,}\.)+))([a-zA-Z]{2,4})(\]?)/)]],
                    my_SpecificaSitoWebSedeLegaleII: '',
                    my_AderentiAII: this.fb.group({
                        my_ElAderentiAII: this.fb.array([]),
                    }),
                    my_RappresentanteCoopCognomeII: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_RappresentanteCoopCognomeII')],
                    my_RappresentanteCoopNomeII: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_RappresentanteCoopNomeII')],
                    my_RappresentanteCoopCodFiscII: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_RappresentanteCoopCodFiscII')],
                    my_TipoRevisioneII: '',
                    my_CkProposteII: ['', null, this.validatorsService.my_CkProposteII],
                    my_sec8: { my_sec9: '' },
                    my_CkProvvedimendoDiII: ['', null, this.validatorsService.my_CkProvvedimendoDiII],
                    my_CkNominaLiqII: ['', null, this.validatorsService.my_CkNominaLiqII],
                    my_EventAltreNotiz: ['', null, this.validatorsService.my_EventAltreNotiz],
                    my_OssControded: [''],
                    my_CkConoscSoci: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_CkConoscSoci')],
                    my_SpecConoscSoci: ['', null, this.validatorsService.my_SpecConoscSoci],
                    my_RisultanzeAccert: this.fb.group({
                        my_ElRisultanzeAccert: this.fb.array([]),
                    }),
                    my_FirmaLegaleRappresentanteII: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_FirmaLegaleRappresentanteII')],
                    my_DescProvinciaSedeLegaleII: '',
                    my_DescComuneSedeLegaleII: '',
                    my_DescSezEnteII: '',
                    my_DataScadenzaAccertamento: '',
                    my_RegimeDerogatorioProvalenzaII: ['', null, this.validatorsService.defaultAccertamentoValidator('my_FirmaLegaleRappresentanteII')],
                    my_DescRegimeDerogatorioPrevalenzaII: '',
                    my_CkTipoAccertamento: ['', null, this.validatorsService.my_CkTipoAccertamento],
                    my_LabelRelazMancatoAccertaz: 'RELAZIONE DI MANCATO ACCERTAMENTO',
                    my_CkAltriFattiProvv: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_CkAltriFattiProvv')],
                    my_GiudizioConclusivoII: ['', null, this.validatorsService.defaultValidatorConTipoAccertamento('my_GiudizioConclusivoII')],
                    my_CkAllegataVisura: '0',
                    my_CkAllegatoAltro: '0',
                    my_AllegatoAltroSpecif: [
                        '',
                        null,
                        // this.validators.my_AllegatoAltroSpecif, //// verificare
                    ],
                    my_RisultanzeMancatoAccertamento: [
                        '',
                        null,
                        // this.validators.defaultValidatorConTipoAccertamento('my_RisultanzeMancatoAccertamento'), //// verificare
                    ],
                    my_Ck_SiRecaPressoEnte: '0',
                    my_RilevaPressoEnte: ['', null, this.validatorsService.my_RilevaPressoEnte],
                    my_LabelSezioneIIAccertaz: 'SEZIONE II - Accertamento',
                    my_NumeroNotaLetteraIncarico: ['', null, this.validatorsService.my_NumeroNotaLetteraIncarico],
                    my_DataLetteraIncarico: ['', null, this.validatorsService.my_DataLetteraIncarico],
                    my_NumeroNotaPrecaricato: '0',
                    my_CkRientranteInRegimeDerogatorioII: '0',
                    my_LocalitaSedeLegaleII: '',
                    my_SanzioniAccessorie: this.fb.group({
                        my_ElSanzioniAccessorie: this.fb.array([]),
                    }),
                    my_LuogoAccertamento: ['---', null, this.validatorsService.my_LuogoAccertamento],
                    my_SpecificaLuogoAccertamento: ['', null, this.validatorsService.my_SpecificaLuogoAccertamento],
                    my_PECcciII: '',
                    my_AltraPECII: [
                        '',
                        [
                            CoopValidators.pattern(
                                /([a-zA-Z0-9_\-\.]+)@((([a-zA-Z0-9\-]{1,}\.)+))([a-zA-Z]{2,4})(\]?)/,
                                'Verifica il campo PEC da visura - inserire "non presente" se la cooperativa non ha comunicato la Pec al Registro imprese'
                            ),
                        ],
                    ],
                    my_EsitoRaccomandataDiffidaFareAccertamento: ['', null, this.validatorsService.contrattoDefaultValidator('my_EsitoRaccomandataDiffidaFareAccertamento')],
                    my_RaccomandataDiffidaFareAccertamento: '',
                    my_AllegatoVisura: '',
                    my_AllegatoCopiaBiancioAccertamento: '',
                    my_AltriAllegatiAccertamento: this.fb.group({
                        my_AltroAllegatoAccertamento: this.fb.array([]),
                    }),
                    my_SchedaPropostaGestioneCommII: this.fb.group({
                        my_ckProspettScopoSocII: ['', null, this.validatorsService.my_SchedaPropostaGestioneCommIIValidator('my_ckProspettScopoSocII')],
                        my_descProspettScopoSocII: ['', null, this.validatorsService.my_SchedaPropostaGestioneCommIIValidator('my_descProspettScopoSocII')],
                        my_ckRisFinProsecuzioneAttSocII: ['', null, this.validatorsService.my_SchedaPropostaGestioneCommIIValidator('my_ckRisFinProsecuzioneAttSocII')],
                        my_descRisFinProsecuzioneAttSocII: ['', null, this.validatorsService.my_SchedaPropostaGestioneCommIIValidator('my_descRisFinProsecuzioneAttSocII')],
                        my_descInizCommGovernativoII: ['', null, this.validatorsService.my_SchedaPropostaGestioneCommIIValidator('my_descInizCommGovernativoII')],
                    }),
                    my_SchedaPropostaScioglimentoII: this.fb.group({
                        my_ckNonPersegScMutuaII: '0',
                        my_ckImpossRaggScopoII: '0',
                        my_ckNoDepBil2AnniII: '0',
                        my_ckNoAttiGest2AnniII: '0',
                        my_descArt2545RicII: ['', null, this.validatorsService.my_descArt2545RicII],
                        my_ckBeniImmobiliII: ['', null, this.validatorsService.propostaScioglValidator('my_ckBeniImmobiliII')],
                        my_ckBeniMobiliRegistrII: ['', null, this.validatorsService.propostaScioglValidator('my_ckBeniMobiliRegistrII')],
                        my_ckValAttivoNecessLiquidII: ['', null, this.validatorsService.propostaScioglValidator('my_ckValAttivoNecessLiquidII')],
                        my_descRisultUltBilAppII: ['', null, this.validatorsService.propostaScioglValidator('my_descRisultUltBilAppII')],
                        my_ckPresuppostiArt223II: ['', null, this.validatorsService.propostaScioglValidator('my_ckPresuppostiArt223II')],
                    }),
                    my_SchedaPropostaSostLiquidCancelRegImpreII: this.fb.group({
                        my_descNatRitardoLiquidII: ['', null, this.validatorsService.sostiuzioneLiquidatoreValidator('my_descNatRitardoLiquidII')],
                        my_descUlterMotivazII: ['', null, this.validatorsService.sostiuzioneLiquidatoreValidator('my_descUlterMotivazII')],
                        my_ckDepBil5EserciziII: ['', null, this.validatorsService.sostiuzioneLiquidatoreValidator('my_ckDepBil5EserciziII')],
                        my_ckBeniImmobII: ['', null, this.validatorsService.sostiuzioneLiquidatoreValidator('my_ckBeniImmobII')],
                        my_ckBeniMobRegistrII: ['', null, this.validatorsService.sostiuzioneLiquidatoreValidator('my_ckBeniMobRegistrII')],
                        my_ckNominaLiqAssSociII: '0',
                        my_ckNominaLiqAutGiudII: '0',
                        my_descRisultanzeBilII: '',
                        my_descNominaLiqII: '',
                    }),
                    my_SchedaPropostaLiqCoattaII: this.fb.group({
                        my_descMotivoPropostaII: ['', liquidazioneDefaultValidator('my_descMotivoPropostaII')],
                        my_ckAvvIstanzaFallII: '0',
                        my_ckAvvDecrIngiuntII: '0',
                        my_ckAvvAzEsecII: '0',
                        my_ckAvvProtestiII: '0',
                        my_ckAvvAltroII: '0',
                        my_descAzAvviateII: '',
                        my_ckSituazPatrAggiornII: ['', liquidazioneDefaultValidator('my_ckSituazPatrAggiornII')],
                        my_descSituazPatrAggiornII: ['', liquidazioneDefaultDescValidator('my_descSituazPatrAggiornII', 'my_ckSituazPatrAggiornII')],
                        my_ckOmessoStipContrII: ['', liquidazioneDefaultValidator('my_ckOmessoStipContrII')],
                        my_descOmessoStipContrII: ['', liquidazioneDefaultDescValidator('my_descOmessoStipContrII', 'my_ckOmessoStipContrII', '1')],
                        my_dtaSitPatrimAggiornII: ['', liquidazioneDefaultDescValidator('my_dtaSitPatrimAggiornII', 'my_ckSituazPatrAggiornII', '1')],
                        my_sitPatrAggTotCreditiII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggTotCreditiII', 'my_ckSituazPatrAggiornII', '1')],
                        my_sitPatrAggImmMatII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggImmMatII', 'my_ckSituazPatrAggiornII', '1')],
                        my_sitPatrAggRimanII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggRimanII', 'my_ckSituazPatrAggiornII', '1')],
                        my_sitPatrAggPatrNettoII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggPatrNettoII', 'my_ckSituazPatrAggiornII', '1')],
                        my_sitPatrAggTotDebII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggTotDebII', 'my_ckSituazPatrAggiornII', '1')],
                        my_descEventOssII: '',
                        my_sitPatrAggTotPAssII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggTotPAssII', 'my_ckSituazPatrAggiornII', '1')],
                        my_sitPatrAggDebEntrEsSuccII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggDebEntrEsSuccII', 'my_ckSituazPatrAggiornII', '1')],
                        my_sitPatrAggAttCircII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggAttCircII', 'my_ckSituazPatrAggiornII', '1')],
                        my_sitPatrAggImmobII: ['', liquidazioneDefaultDescValidator('my_sitPatrAggImmobII', 'my_ckSituazPatrAggiornII', '1')],
                    }),
                    my_Ck_InviataPEC_LR: '',
                    my_EsitoPEC_LR: ['', null, this.validatorsService.my_EsitoPEC_LR],
                    my_CkInviataLettera: '',
                    my_CkInviataRaccomandataDiffidaPrendereContatto: [
                        '',
                        null,
                        this.validatorsService.contrattoDefaultValidator('my_CkInviataRaccomandataDiffidaPrendereContatto'),
                    ],
                    my_EsitoLettera: ['', null, this.validatorsService.my_EsitoLettera],
                    my_IndirizzoDiffida: ['', null, this.validatorsService.contrattoDefaultValidator('my_IndirizzoDiffida')],
                    my_indicazioniAlRevisoreApp: [''],
                    my_RisultIndicazioniAlRevisoreApp: [],
                }),
            },
            {
                updateOn: 'change',
                validators: [...SezIIAccertamentoFormValidators, ...[altreNotLibriSocialiRules.my_DescVertenzeGiudiz]],
            }
        );
    }
}
